// Dependencies
import styled from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    display: block;
    position: relative;

    width: 104px;
    height: 104px;

    .wrapper {
        position: relative;

        height: 100%;
        width: 100%;

        canvas {
            height: 100%;
            width: 100%;
        }

        .title-wrapper {
            display: flex;
            flex-direction: column;
            position: absolute;
            text-align: center;
            transform: translate(-50%, -50%);

            top: 50%;
            left: 50%;

            .value {
                font-family: "Nunito", sans-serif;
                font-style: normal;
                font-size: 1rem;
                font-weight: 600;

                letter-spacing: 0;
                line-height: 1.375;

                color: ${theme.colors.base[500]};
            }

            .label {
                font-family: "Nunito", sans-serif;
                font-style: normal;
                font-size: 0.75rem;
                font-weight: 400;

                letter-spacing: 0.01em;
                line-height: 1.333;

                color: ${theme.colors.base[300]};
            }
        }
    }
`;
